import * as React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@mui/material/Typography";
import UseStyles from "../css/styles";
import ArticleIcon from "@mui/icons-material/Article";
import ScienceIcon from "@mui/icons-material/Science";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { ApptContext } from "../store";
import { AdminSetting } from "../api";	//FB  9219

// Update log
// FB  6192   02/06/2023  DK  Added page to handle Appointments view
// FB  9219   08/09/2024  MS  show/hide book appointment button

export default function AppointmentCard(props: any) {
  const styles = UseStyles();
  const navigate = useNavigate();
  const { state, dispatch } = useContext(ApptContext);
  const handleAppointment = () => {
    state.AppointmentType = "";
    navigate("/user/bookappointment/index");
  }
  //FB 9219 BEGIN
  const [showBookAppintmentButton, setshowBookAppintmentButton] = React.useState(true);
  React.useEffect(() => {
    allowBookAppointment();//FB 8817
  }, []);
  async function allowBookAppointment() {
    var data = await AdminSetting("Allow_Portal_Appointment_Booking");
    if (data == "true") {
      setshowBookAppintmentButton(true);
    }
    else
      setshowBookAppintmentButton(false);
  }
  //FB 9219 END
  return props.isempty ? (
    <Card sx={{ display: "flex", borderRadius: "10px", minHeight: "215px" }}>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box sx={{ padding: 2 }}>
          <Typography component="div" variant="subtitle1">
            <b>{props.parent}</b>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <CardContent sx={{ flex: "1 0 auto", pointerEvents: "none" }}>
            <Typography variant="subtitle2" component="div">
              When you start booking appointments, You can keep track of your{" "}
              {props.parent} here.
            </Typography>
          </CardContent>
          <CardActions>
            <Button
              variant="contained"
              className={styles.navigationButton}
              onClick={handleAppointment}
              style={{ display: showBookAppintmentButton ? "block" : "none" }} //FB 9219
            >
              Book an Appointment
            </Button>
          </CardActions>
        </Box>
      </Box>
    </Card>
  ) : (
    <Card sx={{ display: "flex", borderRadius: "10px", minHeight: "215px" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          paddingTop: "30px",
          paddingBottom: "50px",
        }}
      >
        <Box className={styles.flexcenter_Grid} sx={{ padding: 2 }}>
          <Typography component="div" variant="subtitle1">
            <label>
              {new Date(props.date)
                .toLocaleDateString("en-US", {
                  month: "short",
                })
                .toUpperCase()}
              <br></br>
              {new Date(props.date).toLocaleDateString("en-US", {
                day: "numeric",
              })}
              <br></br>
              {new Date(props.date).toLocaleDateString("en-US", {
                year: "numeric",
              })}
            </label>
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <CardContent sx={{ flex: "1 0 auto", pointerEvents: "none" }}>
            <Typography component="div" variant="subtitle1">
              <b>{props.type}</b>
            </Typography>
            <Typography variant="subtitle2" component="div">
              {props.provider}
            </Typography>
            <Typography variant="subtitle2" component="div">
              {props.location}
            </Typography>
            <Typography variant="subtitle2" component="div">
              {props.time}
            </Typography>
          </CardContent>
          {props.parent === "pastAppointments" ? (
            <CardActions>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <a href="#">
                  <ArticleIcon />
                  <span style={{ paddingLeft: 5 }}>View appointment notes</span>
                </a>
                <a href="#">
                  <ScienceIcon />
                  <span style={{ paddingLeft: 5 }}>View test results</span>
                </a>
              </Box>
            </CardActions>
          ) : (
            <> </>
            // <CardActions>
            //   <Button variant="contained" className={styles.navigationButton}>
            //     Reschedule
            //   </Button>
            // </CardActions>
          )}
        </Box>
      </Box>
    </Card>
  );
}
